module.exports = __webpack_public_path__ + "static/media/whatsapp.49218a68.svg";